import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import { Box, Button } from "@mui/material";
import { Link } from "react-router";

import { useAuth } from "@/auth/authContext";
import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/layout/PageHeader";

/**
 * 全站首頁：**跨服務**的儀表與統計。
 *
 * 這一頁刻意是空的，而且缺的是後端不是前端。跨服務的數字沒辦法從現有的
 * API 拼出來：
 *
 *   - `/me/` 只給「我能進哪些服務、有哪些權限」，沒有任何業務數字
 *   - 每個服務自己的列表端點是分頁的，把七個服務的第一頁加起來不是總數
 *   - 「待我處理的事情」需要後端跨服務查詢，那是一個新端點而不是前端的迴圈
 *
 * 所以正確的做法是等 `GET /me/summary/`（或類似的彙總端點）出現，而不是
 * 現在用前端多打幾個請求硬湊一個會騙人的數字。
 *
 * 路徑是 `/`，標誌與「總覽」都指向這裡 —— 登入後第一眼看到的就是這一頁。
 */
export function OverviewPage() {
  const { me } = useAuth();
  const identity = [me?.display_name, me?.department].filter(Boolean).join(" · ");

  return (
    <>
      <PageHeader
        crumbs={[{ label: "總覽" }]}
        title="總覽"
        description={identity ? `${identity} · 跨服務的儀表與統計` : "跨服務的儀表與統計"}
      />

      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "auto", px: 3, pb: 3 }}>
        <EmptyState
          icon={SpaceDashboardOutlinedIcon}
          title="跨服務儀表尚未實作"
          description={
            <>
              這一頁要放的是橫跨所有服務的數字（待我處理、各服務的量能、趨勢）。
              現有的 API 給不出這些：/me/ 只有權限資訊，各服務的列表端點是分頁的，
              把每個服務的第一頁加起來並不是總數。等後端提供彙總端點再接上。
            </>
          }
          action={
            <Button component={Link} to="/services" variant="contained">
              先去服務清單
            </Button>
          }
        />
      </Box>
    </>
  );
}
